/**
 * i18n — react-i18next initialisation.
 *
 * Translations live in public/locales/{lng}/{ns}.json and are loaded lazily
 * at runtime via i18next-http-backend, so locale files can be updated
 * without a full application rebuild.
 *
 * Import this module once at the application entry point (main.tsx) before
 * React renders. All components may then call useTranslation() freely.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const SUPPORTED_LOCALES = ["en", "en-NZ", "en-US", "es"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: SUPPORTED_LOCALES,
    fallbackLng: "en",
    defaultNS: "common",
    ns: [
      "common",
      "collections",
      "revenue-forecasting",
      "fraud",
      "ai-assistants",
      "settings",
      "shell",
    ],
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      // React already escapes values — no need for i18next to do so too.
      escapeValue: false,
    },
  });

export default i18n;
